export default "__VITE_ASSET__D5wAfx_8__"